import * as planogramList from './full'
import * as planogramShortList from './short'

import { Planogram, PlanogramShort } from 'app/types/machines/planogram'

export const allPlanogramsShort: PlanogramShort[] = Object.values(
    planogramShortList,
).sort((previous, current) => previous.name.localeCompare(current.name))

export const allPlanograms: Planogram[] = Object.values(planogramList).sort(
    (previous, current) => previous.name.localeCompare(current.name),
)
